const Footer = () => {
  return (
    <div class="container">
      <footer class="py-3 my-4">
        <ul class="nav justify-content-center border-bottom pb-3 mb-3">
          <li class="nav-item">
            <a href="/" class="nav-link px-2 text-muted">
              Home
            </a>
          </li>
          <li class="nav-item">
            <a
              href="/River-Level-Project/about"
              class="nav-link px-2 text-muted"
            >
              About
            </a>
          </li>
          <li class="nav-item">
            <a
              href="/River-Level-Project/contact"
              class="nav-link px-2 text-muted"
            >
              Contact
            </a>
          </li>
        </ul>
        <p class="text-center text-muted">© 2023 Joshua Miller</p>
      </footer>
    </div>
  );
};

export default Footer;
